import PageSetup from "../../components/PageSetup";
import CategoriesList from "./CategoriesList";

export default function TestsBySubject() {


    return (
        <PageSetup>
            <CategoriesList />
        </PageSetup>
    )
}